import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Settings } from "luxon";

Settings.defaultLocale = "en";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
